import PropTypes from 'prop-types';
import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        cancelButton: {
            fontSize: '16px',
            padding: '6px 16px'
        }
    }, globalStyles);
};

class MinorButton extends React.PureComponent {

    render() {

        const { classes, disabled } = this.props;

        return (
            <Button
                disabled={disabled}
                data-test={this.props["data-test"]}
                variant="text"
                onClick={this.props.onClick}
                className={classes.cancelButton}>
                {this.props.children || "Select"}
            </Button>
        );
    }
}

MinorButton.defaultProps = {
    disabled: false
};

MinorButton.propTypes = {
    disabled: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(MinorButton);